// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__3DleY","text":"SelectPayment_text__2uVZi","title":"SelectPayment_title__37Ae_","btn":"SelectPayment_btn__3QvyZ"};